module.exports = __webpack_public_path__ + "img/ErrorL.5b04ab9c.png";